var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl';
import { columnMinWidth } from '../../../../utils/tableUtils';
import ActivityStatus from '../../../../data/ActivityStatus';
import DateTime from '../../../components/ui/DateTime/DateTime';
import { ApplicationContext } from '../../../../ApplicationContext';
import Signals from '../../../../signals/Signals';
import UpdateManualAssetOverlay from '../UpdateManualAssetOverlay';
import AssetActivityStatus from "../../../components/ui/AssetActitivyStatus/AssetActivityStatus";
import AssetBatteryStatus from "../../../components/ui/AssetBatteryStatus/AssetBatteryStatus";
import UpdateAssetOverlay from '../UpdateAssetOverlay';
import AssetIcon from '../AssetIcon';
import Color from 'color';
import { SwatchesPicker } from 'react-color';
import { Row, Input, Button } from 'reactstrap';
import BasicFormGroup from '../../../components/ui/BasicFormGroup/BasicFormGroup';
import IconSelector from '../../../components/ui/IconSelector/IconSelector';
import CloseButton from '../../../components/ui/CloseButton/CloseButton';
import UpdateAssetIconCommand from '../../../../commands/assets/UpdateAssetIconCommand';
import { createErrorResponse } from '../../../../utils/errorUtils';
import GetOrganisationAssetsCommand from '../../../../commands/assets/GetOrganisationAssetsCommand';
import "../../../components/ui/DeviceBatteryStatus/device-battery-status.scss";
import DeviceDetailWidget from '../../../components/ui/DeviceDetailWidget/DeviceDetailWidget';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetDetailWidget = /** @class */ (function (_super) {
    __extends(AssetDetailWidget, _super);
    /**
     *
     * @param props
     */
    function AssetDetailWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            displayColorPicker: false,
            displayIconPicker: false,
            iconColor: _this.props.assetModel.iconColor,
        };
        _this.onIconSelect = _this.onIconSelect.bind(_this);
        _this.removeIcon = _this.removeIcon.bind(_this);
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onUpdateAsset = _this.onUpdateAsset.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    AssetDetailWidget.prototype.componentDidMount = function () {
        var assetModel = this.props.assetModel;
        this.setState({
            selectedIconName: assetModel.properties.iconName,
        });
    };
    /**
     *
     * @return {*}
     */
    AssetDetailWidget.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, assetModel = _a.assetModel;
        var _b = this.state, iconColor = _b.iconColor, selectedIconName = _b.selectedIconName, displayColorPicker = _b.displayColorPicker, displayIconPicker = _b.displayIconPicker;
        var devices = assetModel.devices;
        var fuelUsedDate = new Date(assetModel.fuelUsedDateTimeUtc);
        var cumulativeOperatingHoursDate = new Date(assetModel.cumulativeOperatingHoursDateTimeUtc);
        var batteryPowerRemainingFourBarsDate = new Date(assetModel.batteryPowerRemainingFourBarsDateTimeUtc);
        var locationTimeClasses = '';
        switch (assetModel.properties.activityStatus) {
            case ActivityStatus.EXPIRED:
                locationTimeClasses = 'fe fe-alert-circle text-warning mr-2';
                break;
            case ActivityStatus.NONE:
                locationTimeClasses = 'fe fe-x-circle text-danger mr-2';
                break;
            case ActivityStatus.RECENT:
                locationTimeClasses = 'fe fe-clock mr-2';
                break;
        }
        return (React.createElement("div", { className: "w-100" },
            displayIconPicker &&
                React.createElement("div", { style: { zIndex: "1000" }, className: "ml-4 mr-4 position-absolute bg-white px-4 pt-2 box-shadow" },
                    React.createElement(CloseButton, { onClick: function () {
                            // Reset icon and iconColor in the state and close pop up
                            _this.setState({
                                selectedIconName: assetModel.iconName,
                                iconColor: assetModel.iconColor,
                                displayIconPicker: false,
                                displayColorPicker: false
                            });
                        } }),
                    React.createElement(Row, { className: "justify-content-between" },
                        React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.color' }), htmlFor: 'color' },
                            React.createElement(Input, { id: "color", className: "form-control form-control-append", name: "color", type: "text", style: {
                                    cursor: 'pointer',
                                    backgroundColor: iconColor.hex(),
                                    color: iconColor.hex(),
                                }, onClick: function () {
                                    _this.setState({ displayColorPicker: !displayColorPicker });
                                }, value: ' ' }),
                            displayColorPicker &&
                                React.createElement("div", { className: 'position-absolute', style: { zIndex: 1000 } },
                                    React.createElement(SwatchesPicker, { color: iconColor.hex(), onChange: this.onColorChange }))),
                        React.createElement(BasicFormGroup, { classNamesForFormField: "h-100" },
                            React.createElement("div", { className: "d-flex align-items-end" },
                                selectedIconName &&
                                    React.createElement(Button, { className: "btn btn-warning", onClick: this.removeIcon },
                                        React.createElement(FormattedMessage, { id: "asset.detail.popup.icon.remove" })),
                                React.createElement(Button, { color: "dark", onClick: this.onSubmit },
                                    React.createElement(FormattedMessage, { id: "asset.detail.popup.icon.save" }))))),
                    React.createElement(Row, null,
                        React.createElement(BasicFormGroup, { classNamesForFormField: "justify-content-center", label: intl.formatMessage({ id: 'asset.create.overlay.field.icons' }), htmlFor: 'icon' },
                            React.createElement(IconSelector, { onSelect: this.onIconSelect, selectedIconName: selectedIconName, color: iconColor })))),
            !displayIconPicker &&
                React.createElement("div", { className: 'position-absolute w-100 d-flex justify-content-end', style: { paddingRight: '10%' } },
                    React.createElement("div", { style: { cursor: 'pointer' }, onClick: function () {
                            _this.setState({ displayIconPicker: !displayIconPicker });
                        } }, assetModel.iconName ?
                        React.createElement(AssetIcon, { defaultSrc: "/assets/images/asset-icons/edit-3.svg", assetModel: assetModel, height: "5lh" })
                        :
                            React.createElement(React.Fragment, null,
                                React.createElement(AssetIcon, { src: "/assets/images/asset-icons/edit-3.svg", assetModel: assetModel, height: "3lh" }),
                                React.createElement(FormattedMessage, { id: "asset.detail.label.edit.icon" })))),
            React.createElement("table", { className: "w-100" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                            React.createElement(FormattedMessage, { id: "map.asset.popup.label.alias" })),
                        React.createElement("td", { className: "alias" }, assetModel.properties.alias != "" ? assetModel.properties.alias : "")),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                            React.createElement(FormattedMessage, { id: "map.asset.popup.label.id" })),
                        React.createElement("td", null, assetModel.properties.equipmentId != "" ? assetModel.properties.equipmentId : assetModel.properties.serialNumber)),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                            React.createElement(FormattedMessage, { id: "map.asset.popup.label.makemodel" })),
                        React.createElement("td", null,
                            assetModel.properties.make,
                            " / ",
                            assetModel.properties.model)),
                    React.createElement("tr", null,
                        React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                            React.createElement(FormattedMessage, { id: "map.asset.popup.label.serialnumber" })),
                        React.createElement("td", { style: { wordBreak: "break-all" } }, assetModel.properties.serialNumber),
                        React.createElement("td", { className: "w-25" })),
                    assetModel.properties.feedSource &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap align-text-top pr-3" },
                                React.createElement(FormattedMessage, { id: "page.feeds.table.column.provider" }),
                                ":"),
                            React.createElement("td", { colSpan: 2 }, assetModel.properties.feedSource.provider)),
                    assetModel.hasFirmwareVersion &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                                React.createElement(FormattedMessage, { id: "asset.detail.firmwareversion.label" })),
                            React.createElement("td", { colSpan: 2 }, assetModel.properties.feedSource.firmwareVersion)),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 3 },
                            React.createElement("hr", null))),
                    assetModel.hasLastConnectedTimeStamp &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                                React.createElement(FormattedMessage, { id: "asset.detail.lastseen.label" })),
                            React.createElement("td", { colSpan: 2 },
                                React.createElement(AssetActivityStatus, { asset: assetModel }))),
                    assetModel.hasLatestBatteryFourSample &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                                React.createElement(FormattedMessage, { id: "asset.detail.batterystatus.label" })),
                            React.createElement("td", { colSpan: 2 },
                                React.createElement(AssetBatteryStatus, { asset: assetModel }),
                                assetModel.properties.batteryPowerRemainingFourBarsDateTime &&
                                    React.createElement("span", { className: "small text-muted d-block" },
                                        React.createElement(DateTime, { date: batteryPowerRemainingFourBarsDate })))),
                    devices.map(function (device) {
                        if (device.attachedToAsset) { //TODO related to #536. All related views should re-render when base model is updated
                            return (React.createElement(DeviceDetailWidget, { device: device, onDeviceDetached: function () { return _this.forceUpdate(); } }));
                        }
                    }),
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 3 },
                            React.createElement("hr", null))),
                    assetModel.hasLocation &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap align-text-top pr-3" },
                                React.createElement(FormattedMessage, { id: "map.asset.popup.label.location" })),
                            React.createElement("td", { className: "pb-3", colSpan: 2 },
                                React.createElement("a", { href: assetModel.googleMapsUrl, target: "_blank" },
                                    React.createElement("div", { className: "d-flex justify-content-between w-100" },
                                        assetModel.place,
                                        React.createElement("i", { className: "ml-4 fe fe-external-link" }))),
                                assetModel.locationDateTime &&
                                    React.createElement("span", { className: "small text-muted" },
                                        React.createElement(DateTime, { date: assetModel.locationDateTime, timeClasses: locationTimeClasses })))),
                    assetModel.hasOperatingHours &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap align-text-top pr-3", style: columnMinWidth },
                                React.createElement(FormattedMessage, { id: "map.asset.popup.label.operatinghours" })),
                            React.createElement("td", { className: "pb-3", colSpan: 2 },
                                assetModel.hasOperatingHours ?
                                    React.createElement(FormattedNumber, { value: assetModel.properties.cumulativeOperatingHoursDurationInHours, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 })
                                    : '-',
                                assetModel.hasOperatingHours && assetModel.properties.cumulativeOperatingHoursDateTimeUtc ?
                                    React.createElement("span", { className: "small text-muted d-block" },
                                        React.createElement(DateTime, { date: cumulativeOperatingHoursDate })) : null)),
                    assetModel.properties.fuelUsedInLiters >= 0 &&
                        React.createElement("tr", null,
                            React.createElement("td", { className: "font-weight-bold text-nowrap align-text-top pr-3", style: columnMinWidth },
                                React.createElement(FormattedMessage, { id: "map.asset.popup.label.fuelusage" })),
                            React.createElement("td", { className: "pb-3", colSpan: 2 },
                                assetModel.properties.fuelUsedInLiters && fuelUsedDate.getTime() > 0 ?
                                    React.createElement(FormattedNumber, { value: assetModel.properties.fuelUsedInLiters, style: "unit", minimumFractionDigits: 1, maximumFractionDigits: 1, unit: "liter" }) : '-',
                                assetModel.properties.fuelUsedInLiters && assetModel.properties.fuelUsedDateTimeUtc && fuelUsedDate.getTime() > 0 ?
                                    React.createElement("span", { className: "small text-muted d-block" },
                                        React.createElement(DateTime, { date: fuelUsedDate })) : null)))),
            React.createElement("div", { className: "w-100 d-flex justify-content-end" },
                React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.onUpdateAsset },
                    React.createElement("span", { className: "fe fe-edit-2" }),
                    " ",
                    React.createElement(FormattedMessage, { id: "label.generic.update" })))));
    };
    /**
     *
     * @param color
     * @param event
     */
    AssetDetailWidget.prototype.onColorChange = function (color, event) {
        this.setState({ iconColor: new Color(color.hex), displayColorPicker: false });
    };
    /**
     *
     * @param selectedIconName
     */
    AssetDetailWidget.prototype.onIconSelect = function (selectedIconName) {
        this.setState({ selectedIconName: selectedIconName });
    };
    AssetDetailWidget.prototype.removeIcon = function () {
        this.onIconSelect(null);
    };
    AssetDetailWidget.prototype.onSubmit = function (e) {
        var assetModel = this.props.assetModel;
        var newAssetModel = assetModel;
        var _a = this.state, iconColor = _a.iconColor, selectedIconName = _a.selectedIconName;
        newAssetModel.iconName = selectedIconName;
        newAssetModel.iconColor = iconColor;
        newAssetModel.iconColorRgba = iconColor.rgbNumber();
        var intl = this.props.intl;
        var session = this.context.session;
        var user = session.user;
        this.setState({ displayIconPicker: false, displayColorPicker: false });
        var command = new UpdateAssetIconCommand();
        command.execute(newAssetModel, user.organisation.id, intl).then(this.onSuccess).catch(this.onError);
    };
    /**
     *
     */
    AssetDetailWidget.prototype.onUpdateAsset = function () {
        var assetModel = this.props.assetModel;
        assetModel.isManualAsset ?
            Signals.ShowOverlay.dispatch(React.createElement(UpdateManualAssetOverlay, { assetModel: assetModel }))
            :
                Signals.ShowOverlay.dispatch(React.createElement(UpdateAssetOverlay, { assetModel: assetModel }));
    };
    /**
     *
     */
    AssetDetailWidget.prototype.onSuccess = function () {
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var intl = this.props.intl;
        // Refresh assets
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        // No need for a .then() since the observer will pick up the changes in the asset collection
        command.execute(user.organisation, assetCollection).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
    };
    /**
     *
     * @param error
     */
    AssetDetailWidget.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    AssetDetailWidget.defaultProps = {
        className: ''
    };
    return AssetDetailWidget;
}(React.Component));
AssetDetailWidget.contextType = ApplicationContext;
export default injectIntl(AssetDetailWidget);
